import React from 'react';
import './EarlierAnalyticsWork.css';

const EarlierAnalyticsWork = () => {
  return (
    <section className="earlier-work-page">
      <div className="earlier-work-content">
        <h1>Earlier Analytics &amp; Measurement Work</h1>
        <p className="earlier-work-subtitle">
          Implemented GA4, Google Tag Manager, Search Console reporting, and ecommerce measurement to
          improve visibility into traffic, engagement, conversion behavior, and campaign performance.
        </p>

        <section className="earlier-work-section">
          <h2>Ecommerce Site</h2>
          <p>
            Set up Google Analytics 4 and Google Tag Manager on an ecommerce site to track ecommerce
            events, on-site engagement, and traffic sources that hadn't been measured consistently
            before. Used Search Console to identify and resolve indexing and data-quality issues, then
            built reporting around conversion behavior and campaign performance so decisions could be
            based on actual visitor data instead of guesswork.
          </p>
          <img
            src="/images/cof-organic.png"
            alt="Ecommerce traffic and engagement trend"
            className="earlier-work-image"
          />
        </section>

        <section className="earlier-work-section">
          <h2>Community Bank</h2>
          <p>
            Configured Google Tag Manager, Google Analytics, and Google Search Console for a community
            bank's website to establish reliable tracking and visibility where none had existed. Ensured
            new and existing pages were indexed correctly, resolved data-quality issues surfaced in
            Search Console, and built reporting to track traffic, engagement, and conversion trends
            across the site.
          </p>
        </section>

        <section className="earlier-work-section">
          <h2>What This Covered</h2>
          <ul>
            <li>GA4 implementation and event configuration for ecommerce and conversion tracking.</li>
            <li>Google Tag Manager setup for consistent, maintainable tag and trigger management.</li>
            <li>Search Console monitoring to catch and resolve indexing and data-quality issues.</li>
            <li>Reporting on traffic, engagement, conversion behavior, and campaign performance.</li>
          </ul>
        </section>
      </div>
    </section>
  );
};

export default EarlierAnalyticsWork;
